<template lang='pug'>
  span
    v-chip(v-for='(item, index) in value' :key='index') {{item.name}}
</template>

<script>
export default {
  name: 'ChipNames',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    }
  }
};
</script>

<style scoped>

</style>
